import { Injectable, Signal } from '@angular/core';
import { ILeadData, ILeadModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { ILeadState, LeadActions, LeadSelectors } from '../store';

@Injectable({
  providedIn: 'root'
})
export class LeadStore extends StateAccessService<ILeadState> {
  readonly state$: Observable<ILeadState>;

  readonly data$$: Signal<ILeadData>;
  readonly model$$: Signal<ILeadModel>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(LeadSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(LeadSelectors.data);
  }

  dispatchLeadReset() {
    this.stateFacade.dispatch(LeadActions.reset());
  }
  dispatchLeadLoad() {
    this.stateFacade.dispatch(LeadActions.load());
  }
  dispatchLeadLoadSuccess({ model, data }: { model: ILeadModel; data: ILeadData }) {
    this.stateFacade.dispatch(LeadActions.loadSuccess({ model, data }));
  }
  dispatchLeadSubmit(model: ILeadModel) {
    this.stateFacade.dispatch(LeadActions.submit({ model }));
  }
  dispatchLeadSubmitSuccess({ model, data }: { model: ILeadModel; data: ILeadData }) {
    this.stateFacade.dispatch(LeadActions.submitSuccess({ model, data }));
  }
}
